// src/components/strumenti/LimiteCavoEthernet.js
import React, { useState } from "react";
import { RefreshCw } from "lucide-react";
import { leggiNumero } from "../../utils/numeriStrumenti";

const inp = { padding:"10px 12px", border:"1px solid #e5e7eb", borderRadius:8, fontSize:14, fontFamily:"'Inter',sans-serif", outline:"none", width:"100%" };
const lbl = { fontSize:11, fontWeight:600, color:"#6b7280", display:"block", marginBottom:4 };

const CATEGORIE = {
  cat5e: { label:"Cat 5e", velocitaMax:"1 Gbps", limite:100 },
  cat6:  { label:"Cat 6",  velocitaMax:"1 Gbps (10 Gbps fino a 55m)", limite:100 },
  cat6a: { label:"Cat 6a", velocitaMax:"10 Gbps", limite:100 },
  cat7:  { label:"Cat 7",  velocitaMax:"10 Gbps", limite:100 },
};

export default function LimiteCavoEthernet() {
  const [lunghezza, setLunghezza] = useState("");
  const [categoria, setCategoria] = useState("cat6");

  const L = leggiNumero(lunghezza)||0;
  const cat = CATEGORIE[categoria];
  const entroLimite = L>0 && L<=cat.limite;
  const superaLimite = L>cat.limite;

  return (
    <div>
      <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:12, marginBottom:16 }}>
        <div>
          <label style={lbl}>Lunghezza tratta (m)</label>
          <input value={lunghezza} onChange={e=>setLunghezza(e.target.value)} style={inp} placeholder="Es. 85"/>
        </div>
        <div>
          <label style={lbl}>Categoria cavo</label>
          <select value={categoria} onChange={e=>setCategoria(e.target.value)} style={inp}>
            {Object.entries(CATEGORIE).map(([k,c]) => <option key={k} value={k}>{c.label}</option>)}
          </select>
        </div>
      </div>

      {L>0 && (
        <div style={{ background: superaLimite ? "#fef2f2" : "#eff6ff", border:`1px solid ${superaLimite?"#fca5a5":"#bfdbfe"}`, borderRadius:10, padding:"14px 16px", textAlign:"center" }}>
          <div style={{ fontSize:16, fontWeight:800, color: superaLimite ? "#dc2626" : "#2563eb" }}>
            {superaLimite ? "⚠️ Supera il limite standard" : "✅ Entro il limite standard"}
          </div>
          <div style={{ fontSize:12, color:"#6b7280", marginTop:6 }}>Limite {cat.label}: <strong>{cat.limite} m</strong> · Velocità: {cat.velocitaMax}</div>
          {superaLimite && (
            <div style={{ fontSize:11, color:"#991b1b", marginTop:6 }}>Valutare un ripetitore/switch intermedio, o passare in fibra ottica per la tratta</div>
          )}
        </div>
      )}
      <div style={{ fontSize:10, color:"#9ca3af", marginTop:8, textAlign:"center" }}>
        100 metri è il limite standard Ethernet su rame (100BASE-TX / 1000BASE-T / 10GBASE-T) indipendentemente dalla categoria — cambia la velocità massima raggiungibile, non la lunghezza massima.
      </div>

      <button onClick={()=>{setLunghezza("");setCategoria("cat6");}}
        style={{ marginTop:12, display:"flex", alignItems:"center", gap:6, fontSize:12, color:"#9ca3af", background:"none", border:"none", cursor:"pointer" }}>
        <RefreshCw size={12}/> Azzera
      </button>
    </div>
  );
}
